import React from "react";
import classNames from "classnames/bind";
import styles from "../../AddJobModal.module.scss";
import { JobFormData, JobFormErrors } from "../../types/add-job.types";

const cx = classNames.bind(styles);

interface JobTextAreasProps {
  formData: JobFormData;
  errors: JobFormErrors;
  onFieldChange: (field: keyof JobFormData, value: any) => void;
  onErrorFieldChange: (field: keyof JobFormErrors, value: string) => void;
}

const JobTextAreas: React.FC<JobTextAreasProps> = ({
  formData,
  errors,
  onFieldChange,
  onErrorFieldChange,
}) => {
  return (
    <div className={cx("job-text-areas-container")}>
      <div className={cx("item")}>
        <h4 className={cx("item-title")}>Job Description</h4>
        <textarea
          className={cx("textarea", "h-[80px]", {
            "textarea-error": !!errors.jobDescription,
          })}
          placeholder="Enter job description"
          value={formData.jobDescription}
          onChange={(e) => {
            onFieldChange("jobDescription", e.target.value);
            if (!e.target.value.trim()) {
              onErrorFieldChange("jobDescription", "Job description is required");
            } else {
              onErrorFieldChange("jobDescription", "");
            }
          }}
          rows={3}
        />
        {errors.jobDescription && (
          <p className={cx("error-message")}>{errors.jobDescription}</p>
        )}
      </div>

      <div className={cx("item")}>
        <h4 className={cx("item-title")}>Notes (Optional)</h4>
        <textarea
          className={cx("textarea", "h-[110px]")}
          placeholder="Enter notes"
          value={formData.notes}
          onChange={(e) => onFieldChange("notes", e.target.value)}
          rows={4}
        />
      </div>
    </div>
  );
};

export default JobTextAreas;
